import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthInterceptorProvider, HttpLoaderFactory, LayoutModule, MangoInterceptorService } from '@mangosoft/mango-layout';
import { AuthModule } from '@mangosoft/mango-login';
import { CookieService } from 'ngx-cookie-service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { StoreModule } from '@ngrx/store';
import { SystemModulesModule } from './UI/pages/system-modules/system-modules.module';
import { EffectsModule } from '@ngrx/effects';
import { EffectsArray, reducers, metaReducers } from 'projects/access-control/src/app/Infrastructure/Store/index';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'projects/access-control/src/environments/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ClientsModule } from './UI/pages/clients/clients.module';
import { RolesModule } from './UI/pages/roles/roles.module';
import { GroupsModule } from './UI/pages/groups/groups.module';
import { JwtModule } from '@auth0/angular-jwt';
import { UsersModule } from './UI/pages/users/users.module';
import { loadingSpinnerModule } from './UI/commons/loading-spinner/loading-spinner.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ApiInterceptor } from './Infrastructure/interceptors/api.interceptor';
import { ToastrModule } from 'ngx-toastr';
@NgModule({
	declarations: [AppComponent],
	imports: [
		HttpClientModule,
		BrowserModule,
		UsersModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		AuthModule,
		LayoutModule,
		NgxDatatableModule,
		SystemModulesModule,
		ClientsModule,
		StoreModule.forRoot(reducers, { metaReducers }),
		EffectsModule.forRoot(EffectsArray),
		StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
		!environment.production ? StoreDevtoolsModule.instrument() : [],
		MatDialogModule,
		MatButtonModule,
		RolesModule,
		GroupsModule,
		ToastrModule.forRoot({
			timeOut: 3000,
			positionClass: 'toast-bottom-center',
			preventDuplicates: true,
			progressBar: true,
			closeButton: true,
			progressAnimation: 'increasing',
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		JwtModule.forRoot({
			config: {
				tokenGetter: () => {
					return '';
				},
			},
		}),
		loadingSpinnerModule,
	],
	providers: [
		CookieService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ApiInterceptor,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
